<template>
  <div v-resize="maxScrollHeight" :style="{backgroundColor: '#fff', maxWidth: maxWidth}">
    <fin-scrollable-list :style="{maxHeight: maxHeight}">
      <v-list-item-group v-model="selectedItem">
        <template v-for="(item, index) in messages">
          <v-list-item :key="item.id"
                       :two-line="!hideTextPreview"
                       @click="msgClicked(item)">
            <v-list-item-icon class="mt-3 ml-0 mr-1">
              <v-tooltip right>
                <template #activator="{ on, attrs }">
                  <v-icon
                    :color="$finColors.primaryDark"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ messageIcon(item.message.type) }}
                  </v-icon>
                </template>
                <span>{{ item.message.type }}</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="fin-color-primary-dark--text myfinhub-table-column-header">
                <div :style="{display: $vuetify.breakpoint.mdAndUp ? 'flex' : 'block'}">
                  <div :class="item.status === 'READ' ? 'read' : 'unread'"
                       style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0;">
                    <span v-html="item.message.title"/>
                    <div v-if="$vuetify.breakpoint.smAndDown" class="datetime mt-1" style="text-align: right;">
                      {{ item.createdAt | datetime }}
                    </div>
                  </div>
                  <div v-if="$vuetify.breakpoint.mdAndUp" class="datetime"
                       style="flex: 1; margin-left: 20px; text-align: right;">
                    {{ item.createdAt | datetime }}
                  </div>
                </div>
              </v-list-item-title>
              <v-list-item-subtitle v-if="!hideTextPreview" class="fin-color-primary-dark--text">
                <p :class="['ma-0', {'ellipsis': shortTextPreview}]"
                   v-html="shortTextPreview ? stripHtml(item.message.text): item.message.text"/>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="'divider' + index" style="margin: 0 25px"/>
        </template>
      </v-list-item-group>
    </fin-scrollable-list>

    <slot name="actions">
      <div style="text-align: center;">
        <v-btn :to="{name: 'finSpeaker'}"
               class="fin-color-primary-dark--text more"
               style="display: inline-block; margin: 12px auto; height: 30px; cursor: pointer;"
               text>
          <span style="line-height: 30px;">Alle anzeigen</span>
          <v-icon class="ml-2" size="16">icon-arrow-link</v-icon>
        </v-btn>
      </div>
    </slot>
  </div>
</template>

<script>
import SpeakerTools from '@/js/finSpeaker'

export default {
  name: 'FinSpeakerMessages',
  components: {},
  props: {
    /** The messages to display inside a scrollable list, for the structure of a message object see sample or schema.graphql */
    messages: {
      type: Array,
      default: () => []
    },
    /** The max-width of the wrapping div (= scrollable list + show all button beneath) */
    maxWidth: {
      type: String,
      default: '425px'
    },
    /** Only show title + datetime */
    hideTextPreview: {
      type: Boolean,
      default: false
    },
    /** Additional margins/paddings etc. before the messages list, used to calculate the maxHeight data var */
    adjustMaxHeight: {
      type: Number
    },
    /** Message text is displayed as shortened preview message without markup */
    shortTextPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItem: null,
      maxHeight: this.maxScrollHeight,
    }
  },
  methods: {
    messageIcon: SpeakerTools.messageIcon,
    msgClicked(msg) {
      this.$emit('speakerMsgClicked', msg)
    },
    maxScrollHeight() {
      const defaultMaxHeight = '400px'

      if (this.adjustMaxHeight) {
        const height = window.innerHeight
        const app = this.$vuetify.application
        const vmainHeight = app.top + app.bottom + app.footer + this.adjustMaxHeight
        let remainingSpaceWithoutScrollbars = height - vmainHeight

        if (remainingSpaceWithoutScrollbars > defaultMaxHeight) {
          this.maxHeight = defaultMaxHeight
        } else {
          // at least show 2 entries before scrolling (=> xs mobile landscape)
          if (remainingSpaceWithoutScrollbars < 96) {
            remainingSpaceWithoutScrollbars = 96
          }
          this.maxHeight = remainingSpaceWithoutScrollbars + 'px'
        }
      } else {
        this.maxHeight = defaultMaxHeight
      }
    },
    stripHtml(text) {
      let regex = /(<([^>]+)>)/ig
      text = text.replace(regex, "")
      return text
    }
  },
  watch: {
    adjustMaxHeight() {
      this.maxScrollHeight()
    }
  }
}
</script>

<style lang="scss" scoped>
.more {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
}

.unread {
  font-weight: bold;
}

.read {
  font-weight: normal;
}

.datetime {
  font-family: $body-font-family;
  text-transform: uppercase;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.ellipsis{
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
